import { render, staticRenderFns } from "./TransactionTableItem.vue?vue&type=template&id=66e97056&"
import script from "./TransactionTableItem.vue?vue&type=script&lang=ts&"
export * from "./TransactionTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports